export enum DataFocusId {
  WidgetContent = 'WidgetContent',
  ManageMenu = 'ManageMenu',
}
